import { render, staticRenderFns } from "./ModalLegalAge.vue?vue&type=template&id=737a408a&"
import script from "./ModalLegalAge.vue?vue&type=script&lang=js&"
export * from "./ModalLegalAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports